var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBudgets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.25,
    width: 15,
    height: 16.875,
    rx: 4.375,
    stroke: "#495057",
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1244 3.75C13.4696 3.75 13.7553 4.03172 13.698 4.37211C13.6512 4.65038 13.573 4.92314 13.4645 5.18506C13.2761 5.64003 12.9999 6.05343 12.6517 6.40165C12.3034 6.74987 11.89 7.02609 11.4351 7.21455C10.9801 7.403 10.4925 7.5 10 7.5C9.50754 7.5 9.01991 7.403 8.56494 7.21455C8.10997 7.02609 7.69657 6.74987 7.34835 6.40165C7.00013 6.05343 6.72391 5.64003 6.53545 5.18506C6.42696 4.92313 6.34878 4.65038 6.30196 4.37211C6.2447 4.03172 6.53042 3.75 6.8756 3.75C7.22078 3.75 7.49351 4.03407 7.57895 4.36851C7.60829 4.48336 7.64584 4.59624 7.6914 4.70625C7.81698 5.00942 8.00104 5.28489 8.23308 5.51692C8.46511 5.74896 8.74058 5.93302 9.04375 6.0586C9.34692 6.18417 9.67185 6.24881 10 6.24881C10.3281 6.24881 10.6531 6.18417 10.9563 6.0586C11.2594 5.93302 11.5349 5.74896 11.7669 5.51692C11.999 5.28489 12.183 5.00942 12.3086 4.70625C12.3542 4.59624 12.3917 4.48336 12.421 4.36851C12.5065 4.03407 12.7792 3.75 13.1244 3.75Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudgets);
export default __webpack_public_path__ + "static/media/budgets.1d1cd367aba106503808d2cc787ee8fc.svg";
export { ForwardRef as ReactComponent };